$(document).on('change', '.bn_book__feedback-checkbox', function() {
    let that = this,
        isActive,
        wrapper = $(that).parents('.bn_novels-recommends__content'),
        item = $(that).parents('.bn_book__feedback-item'),
        bookId = wrapper.data('book-id'),
        recommendationId = item.data('recommendation-id');

    if (that.checked) {
        isActive = 1;
        item.addClass('active');
    } else {
        isActive = 0;
        item.removeClass('active')
    }

    $.ajax({
        url: '/account/novels/edit-recommendation',
        type: 'POST',
        data: {
            'bookId': bookId,
            'isActive': isActive,
            'recommendationId': recommendationId,
        },
        success: function(response) {
            if (response.limited) {
                wrapper.addClass('limited')
            } else {
                wrapper.removeClass('limited')
            }

            flashNotify(response.message)
        }
    });
});